import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { WidgetsAbstract } from 'src/app/abstract/widgets/widgets.abstract';

@Injectable()
export class WidgetsNotifyDeleteService {
  private notificationSource = new Subject<WidgetsAbstract>();
  // eslint-disable-next-line
  public notifyDeleteReceived = this.notificationSource.asObservable();

  constructor() {
    // Empty
  }

  notifyDelete(widget: WidgetsAbstract) {
    this.notificationSource.next(widget);
    // console.log(widget);
  }
}
